import React, { Suspense, lazy, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './Autenticacao/AuthContext';
import LoadingPage from './LoadingPage';
import LoginPage from './Autenticacao/Login';
import AutenticarDocumentos from './components/PainelGerencial/AutenticarDocumentos/AutenticarDocumentos';
import { useAuth } from './Autenticacao/AuthContext';
import './App.css';
// Carrega o componente protegido de forma dinâmica
const Main = lazy(() => import('./Main'));

console.log(`  ██████╗ ███████╗ ██████╗                
              ██╔════╝ ██╔════╝██╔═══██╗               
              ██║  ███╗█████╗  ██║   ██║               
              ██║   ██║██╔══╝  ██║   ██║               
              ╚██████╔╝███████╗╚██████╔╝               
              ╚═════╝ ╚══════╝ ╚═════╝                
                                                      
               ██████╗ ██████╗ ██╗  ██╗ █████╗ ██████╗ 
              ██╔════╝██╔═══██╗██║  ██║██╔══██╗██╔══██╗
              ██║     ██║   ██║███████║███████║██████╔╝
              ██║     ██║   ██║██╔══██║██╔══██║██╔══██╗
              ╚██████╗╚██████╔╝██║  ██║██║  ██║██████╔╝
              ╚═════╝ ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝`);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/*" element={<ProtectedRoute />} />
          <Route path="/autenticardocumentos" element={<AutenticarDocumentos />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}


function ProtectedRoute() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);

  useEffect(() => {
    // Permite acesso automático em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      setIsAuthenticated(true);
      return;
    }
    const checkAuth = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_AUTHAPI}/validate-token`, {
          withCredentials: true,
        });
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <LoadingPage />; // Enquanto não sabemos, mostra loading
  }

  if (isAuthenticated === false) {
    return <Navigate to="/" />;
  }

  return (
    <Suspense fallback={<LoadingPage />}>
      <Main />
    </Suspense>
  );
}


export default App;
